import {useMutation, useQueryClient} from 'react-query';
import PatchPesticideAdvertisement from '.';

interface IPostPesticideAdvertisementProps {
  onSuccess?: (response: IAddedAdvertisementResponse) => void;
  guid?: string;
}

const usePatchPesticideAdvertisement = ({
  onSuccess,
  guid,
}: IPostPesticideAdvertisementProps) => {
  const queryClient = useQueryClient();

  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IPesticideAdvertisementPayload) => {
      return PatchPesticideAdvertisement(payload, guid);
    },

    onSuccess: data => {
      if (onSuccess) {
        onSuccess(data); // Passing the response to onSuccess
      }

      queryClient.invalidateQueries({queryKey: ['my-ads']}); // Invalidate personal ads
      queryClient.invalidateQueries({queryKey: ['get-store-lab-views']}); // Invalidate store ads
    },
  });

  return {isLoading, mutate, isSuccess};
};
export {usePatchPesticideAdvertisement};
